import { Alert, Collapse, SxProps } from '@mui/material';
import { Stack } from '@mui/system';

type ErrorList = { [id: string]: string };

export type ResponseErrorProps = {
  fieldName: string;
  errors: ErrorList;
  sx?: SxProps;
};

export const ResponseError = ({ fieldName, errors, sx }: ResponseErrorProps) => {
  const error = errors?.[fieldName];
  return (
    <Collapse in={!!error}>
      <Alert severity='error' sx={sx}>
        {error}
      </Alert>
    </Collapse>
  );
};

export type ResponseErrorListProps = {
  errors?: ErrorList;
  excludeKeys?: string[];
  includeKeys?: string[];
};

export const ResponseErrorList = ({
  errors = {},
  includeKeys,
  excludeKeys,
}: ResponseErrorListProps) => {
  let errorList = Object.entries(errors);
  errorList = includeKeys ? errorList.filter(([key, _]) => includeKeys?.includes(key)) : errorList;
  errorList = excludeKeys ? errorList.filter(([key, _]) => !excludeKeys?.includes(key)) : errorList;
  const showList = errorList?.length > 0;
  return (
    <Collapse in={showList}>
      <Stack spacing={2} sx={{ mt: 2 }}>
        {errorList.map(([_, error], key) => (
          <Alert severity='error' key={key}>
            {error}
          </Alert>
        ))}
      </Stack>
    </Collapse>
  );
};
